import { useState } from 'react';
import { TapeDeck } from './components/TapeDeck';
import { ModeSelector, YuMode } from './components/ModeSelector';

/**
 * Main Application Component
 * 
 * Configure your video settings here
 */
function App() {
    const [currentMode, setCurrentMode] = useState<YuMode>('curious');

    // Use Vite's base URL to handle different paths in dev vs production
    const basePath = import.meta.env.BASE_URL || '/';

    return (
        <div style={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden' }}>
            <ModeSelector
                selectedMode={currentMode}
                onSelectMode={setCurrentMode}
            />
            <TapeDeck
                framesPath={`${basePath}frames`}
                framePattern="frame_%04d.webp"
                totalFrames={741}
                eventsPath={`${basePath}data/frame-events.json`}
                currentMode={currentMode}
            />
        </div>
    );
}

export default App;
